/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_seo_f1_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy tools for serious managers`)
};

const es_home_seo_f1_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramientas de F1 Fantasy para managers serios`)
};

const de_home_seo_f1_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1-Fantasy-Werkzeuge für ambitionierte Manager`)
};

const nl_home_seo_f1_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy-tools voor serieuze managers`)
};

const fr_home_seo_f1_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des outils F1 Fantasy pour les managers sérieux`)
};

const it_home_seo_f1_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strumenti F1 Fantasy per manager seri`)
};

const pt_br2_home_seo_f1_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramentas de F1 Fantasy para gerentes sérios`)
};

const pt_home_seo_f1_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramentas de F1 Fantasy para gestores a sério`)
};

const ja_home_seo_f1_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本気のマネージャーのためのF1ファンタジーツール`)
};

const zh_home_seo_f1_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为认真玩家打造的 F1 Fantasy 工具`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_seo_f1_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_seo_f1_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("home_seo_f1_title", locale)
	if (locale === "en") return en_home_seo_f1_title(inputs)
	if (locale === "es") return es_home_seo_f1_title(inputs)
	if (locale === "de") return de_home_seo_f1_title(inputs)
	if (locale === "nl") return nl_home_seo_f1_title(inputs)
	if (locale === "fr") return fr_home_seo_f1_title(inputs)
	if (locale === "it") return it_home_seo_f1_title(inputs)
	if (locale === "pt-BR") return pt_br2_home_seo_f1_title(inputs)
	if (locale === "pt") return pt_home_seo_f1_title(inputs)
	if (locale === "ja") return ja_home_seo_f1_title(inputs)
	return zh_home_seo_f1_title(inputs)
};